import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const LoginIconSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3.25C11.8011 3.25 11.6103 3.32902 11.4697 3.46967C11.329 3.61032 11.25 3.80109 11.25 4C11.25 4.19891 11.329 4.38968 11.4697 4.53033C11.6103 4.67098 11.8011 4.75 12 4.75C12.9521 4.75 13.8948 4.93753 14.7745 5.30187C15.6541 5.66622 16.4533 6.20025 17.1265 6.87348C17.7997 7.5467 18.3338 8.34593 18.6981 9.22554C19.0625 10.1052 19.25 11.0479 19.25 12C19.25 12.9521 19.0625 13.8948 18.6981 14.7745C18.3338 15.6541 17.7997 16.4533 17.1265 17.1265C16.4533 17.7997 15.6541 18.3338 14.7745 18.6981C13.8948 19.0625 12.9521 19.25 12 19.25C11.8011 19.25 11.6103 19.329 11.4697 19.4697C11.329 19.6103 11.25 19.8011 11.25 20C11.25 20.1989 11.329 20.3897 11.4697 20.5303C11.6103 20.671 11.8011 20.75 12 20.75C14.3206 20.75 16.5462 19.8281 18.1872 18.1872C19.8281 16.5462 20.75 14.3206 20.75 12C20.75 9.67936 19.8281 7.45376 18.1872 5.81282C16.5462 4.17187 14.3206 3.25 12 3.25Z"
      fill="currentColor"
    />
    <path
      d="M10.47 9.53082C10.3375 9.38865 10.2654 9.2006 10.2688 9.0063C10.2723 8.812 10.351 8.62662 10.4884 8.4892C10.6258 8.35179 10.8112 8.27308 11.0055 8.26965C11.1998 8.26622 11.3878 8.33834 11.53 8.47082L14.53 11.4708C14.6705 11.6114 14.7493 11.8021 14.7493 12.0008C14.7493 12.1996 14.6705 12.3902 14.53 12.5308L11.53 15.5308C11.4613 15.6045 11.3785 15.6636 11.2865 15.7046C11.1945 15.7456 11.0952 15.7676 10.9945 15.7694C10.8938 15.7712 10.7938 15.7527 10.7004 15.7149C10.607 15.6772 10.5222 15.6211 10.451 15.5499C10.3797 15.4786 10.3236 15.3938 10.2859 15.3004C10.2482 15.207 10.2296 15.107 10.2314 15.0063C10.2332 14.9056 10.2552 14.8063 10.2962 14.7143C10.3372 14.6223 10.3963 14.5395 10.47 14.4708L12.19 12.7508H4C3.80109 12.7508 3.61032 12.6718 3.46967 12.5312C3.32902 12.3905 3.25 12.1997 3.25 12.0008C3.25 11.8019 3.32902 11.6111 3.46967 11.4705C3.61032 11.3298 3.80109 11.2508 4 11.2508H12.19L10.47 9.53082Z"
      fill="currentColor"
    />
  </svg>
);

export const LoginIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={LoginIconSvg} {...props} />
);

export default LoginIcon;

LoginIcon.displayName = "LoginIcon";
